<h1>Tooltips</h1>

<p>Tooltips are available in different flavors.</p>
<p>
  On this screen, all tooltips are displayed by default to make it easier to preview all declinations. Hovering on a text will make the
  tooltip disappear after mouse leave: the tooltip will then behave as a classical tooltip.
</p>
<p>
  Texts with tooltips are focusable, so you can navigate with TAB to focus those elements and check that the tooltip is displayed/hidden on
  focus/blur.
</p>
<p>
  You can hide/show all tooltips or enable/disable tooltips by clicking those buttons:
  <span class="d-inline-flex hgap-2 ml-2">
    <button class="btn secondary" (click)="hideTooltips()">Hide tooltips</button>
    <button class="btn secondary" (click)="showTooltips()">Show tooltips</button>
    <button class="btn secondary" (click)="disabled = !disabled">{{ disabled ? 'Enable' : 'Disable' }} tooltips</button>
  </span>
</p>
<p>
  You can customize the text (even HTML) of the tooltip here:
  <vitamui-input [textarea]="true" class="w-100" [(ngModel)]="tooltipText"></vitamui-input>
</p>

@for (outline of outlineValues; track outline) {
  <h2>{{ outline ? 'Light' : 'Dark' }}</h2>
  @for (color of colors; track color) {
    <h3>{{ color }}</h3>
    <div class="row">
      @for (position of positions; track position) {
        <div class="col my-6">
          <span
            tabindex="0"
            [vitamuiTooltip]="tooltipText || position"
            [vitamuiTooltipPosition]="position"
            [outline]="outline"
            [vitamuiTooltipClass]="color"
            [vitamuiTooltipDisabled]="disabled"
          >
            {{ outline ? 'Light' : 'Dark' }} {{ color }} {{ position }}
          </span>
        </div>
      }
    </div>
  }
}
